module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold Italic.67f5a52b.eot";